export default "__VITE_ASSET__SeTcI7eI__"